<template>
  <div class="admin">
    <v-container class="my-5">
      <v-layout row>
        <v-flex xs12 md6>
          <v-select
            outlined
            :items="totalWeeks"
            label="Week"
            v-model="week"
            @change="getGamesByWeek(week)"
            class="mx-4 primary--text"
            dense
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout row class="hidden-md-and-up">
        <v-btn text color="secondary" @click="showHideGames()"
          >{{ showHide }} All Games</v-btn
        >
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-card class="ma-3" v-if="!hideGames">
            <v-card-text>
              <h2 class="font-weight-bold mb-2">Week {{ week }} Slate</h2>
              <v-divider class="mb-6" />
              <v-select
                right
                clearable
                :items="allConferences"
                label="Filter by Conference"
                v-model="conference"
                item-text="name"
                item-value="abbreviation"
                dense
                class="mt-4 mx-5 mb-0"
                @change="getGamesByConference(conference)"
              ></v-select>
              <v-list two-line>
                <v-list-item-group>
                  <template v-for="(game, index) in games">
                    <v-list-item :key="game.id" @click="addRemoveGame(game)">
                      <template v-slot:default="{}">
                        <v-list-item-content>
                          <v-list-item-title
                            class="font-weight-bold"
                            v-text="
                              game.away_team +
                              (game.neutral_site ? ' vs ' : ' at ') +
                              game.home_team
                            "
                          ></v-list-item-title>
                          <v-list-item-subtitle class="text--primary">{{
                            game.venue
                          }}</v-list-item-subtitle>
                          <v-list-item-subtitle>{{
                            getVenueLocation(game.venue_id)
                          }}</v-list-item-subtitle>
                          <v-list-item-subtitle
                            >{{ game.start_date | formatDate }} |
                            <span v-if="game.start_time_tbd">TBD</span
                            ><span v-else>{{
                              game.start_date | formatTime
                            }}</span></v-list-item-subtitle
                          >
                        </v-list-item-content>
                        <v-list-item-icon>
                          <v-icon
                            v-if="gameAlreadySelected(game)"
                            color="success lighten-1"
                            >star</v-icon
                          >
                          <v-icon v-else color="grey lighten-1"
                            >star_border</v-icon
                          >
                        </v-list-item-icon>
                      </template>
                    </v-list-item>
                    <v-divider
                      v-if="index + 1 < games.length"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md6>
          <v-card class="ma-3">
            <v-card-text>
              <h2 class="font-weight-bold mb-2">
                Selected Games
                <v-avatar
                  v-if="selectedGamesDisplay.length"
                  size="24"
                  class="warning subtitle-2 secondary--text ml-2"
                  >{{ selectedGamesDisplay.length }}</v-avatar
                >
              </h2>
              <v-divider class="mb-6" />
              <v-list two-line>
                <v-list-item-group
                  v-if="!selectedGamesDisplay.length"
                  class="text-center"
                  >No games selected</v-list-item-group
                >
                <v-list-item-group>
                  <template v-for="(game, index) in selectedGamesDisplay">
                    <v-list-item :key="game.id">
                      <template v-slot:default="{}">
                        <v-list-item-content>
                          <v-list-item-title
                            class="font-weight-bold"
                            v-text="
                              game.away_team +
                              (game.neutral_site ? ' vs ' : ' at ') +
                              game.home_team
                            "
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            class="error--text font-weight-bold"
                            >{{
                              pointSpreadDisplay(game.id)
                            }}</v-list-item-subtitle
                          >
                          <v-list-item-subtitle>{{
                            game.venue
                          }}</v-list-item-subtitle>
                          <v-list-item-subtitle>{{
                            getVenueLocation(game.venue_id)
                          }}</v-list-item-subtitle>
                          <v-list-item-subtitle
                            >{{ game.start_date | formatDate }} |
                            <span v-if="game.start_time_tbd">TBD</span
                            ><span v-else>{{
                              game.start_date | formatTime
                            }}</span></v-list-item-subtitle
                          >
                        </v-list-item-content>
                        <v-list-item-action @click="removeGame(game)">
                          <v-btn icon>
                            <v-icon color="grey lighten-1">close</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </template>
                    </v-list-item>
                    <v-layout class="ma-0" row wrap :key="index + '-layout'">
                      <v-checkbox
                        v-model="game.spotlight_game"
                        @click="updateSpotlightSpread(game)"
                        :key="index + '-spot'"
                        class="my-0 ml-3"
                        color="info"
                        label="Spotlight game"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="game.spread_game"
                        @click="updateSpotlightSpread(game)"
                        :key="index + '-spread'"
                        class="my-0 ml-3"
                        color="info"
                        label="Spread game"
                      ></v-checkbox>
                    </v-layout>
                    <v-divider
                      v-if="index + 1 < selectedGamesDisplay.length"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapState, mapGetters } from "vuex";

export default {
  name: "Admin",
  data() {
    return {
      games: [],
      conferences: [],
      conference: null,
      week: 16,
      hideGames: false,
      showHide: "Hide",
    };
  },
  methods: {
    getGamesByWeek(week) {
      axios
        .get(
          "https://api.collegefootballdata.com/games?year=2020&week=" +
            week +
            "&seasonType=regular"
        )
        .then((response) => {
          this.conference = null;
          this.games = response.data;
        });
    },
    getGamesByConference(conference) {
      if (conference) {
        axios
          .get(
            "https://api.collegefootballdata.com/games?year=2020&week=" +
              this.week +
              "&seasonType=regular&conference=" +
              conference
          )
          .then((res) => {
            this.games = res.data;
          });
      } else {
        this.getGamesByWeek(this.week);
      }
    },
    addRemoveGame(game) {
      let selectedGame = this.selectedGames.find((x) => x.id === game.id);
      if (selectedGame) {
        this.$store.dispatch("removeSelectedGame", selectedGame);
      } else {
        this.$store.dispatch("createSelectedGame", game);
      }
    },
    removeGame(game) {
      this.$store.dispatch("removeSelectedGame", game);
    },
    getTeamMascot(teamId) {
      let team = this.allTeams.filter((team) => team.id === teamId)[0];
      if (team) {
        return team.mascot;
      }
      return "";
    },
    getVenueLocation(venueId) {
      let venue = this.allVenues.filter((venue) => venue.id === venueId)[0];
      if (venue) {
        return venue.city + (venue.state ? ", " : "") + venue.state;
      }
      return "";
    },
    gameAlreadySelected(game) {
      return this.selectedGames.find((x) => x.id === game.id);
    },
    updateSpotlightSpread(game) {
      this.$store.dispatch("updateSpotlightSpread", game);
    },
    showHideGames() {
      this.hideGames = !this.hideGames;
      this.showHide = this.hideGames ? "Show" : "Hide";
    },
    pointSpreadDisplay(gameId) {
      let game = this.allSpreads.filter((x) => x.id === gameId)[0];
      return game && game.lines && game.lines.length > 0
        ? game.lines[0].formattedSpread
        : "Spread not available";
    },
  },
  computed: {
    ...mapState([
      "selectedGames",
      "allTeams",
      "allVenues",
      "allConferences",
      "allSpreads",
    ]),
    ...mapGetters(["totalWeeks"]),
    selectedGamesDisplay() {
      return this.selectedGames.filter((x) => x.week === this.week);
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = new Date(val);
      return moment(date).format("MMMM D");
    },
    formatTime(val) {
      if (!val) {
        return "-";
      }
      let date = new Date(val);
      return moment(date).format("h:mm a");
    },
  },
  created() {
    this.getGamesByWeek(this.week);
  },
};
</script>